<template>
  <div class="mx-auto container container--fluid">
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card class="box">
      <v-data-table :headers="headers" :items="configuration_master_list" class="elevation-1 mytable" id="mytable" dense
        :search="search" :items-per-page="-1">
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Configuration Master</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
             <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details background-color="white" class="mr-3">
              </v-text-field>
              <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="success" small class="mr-2" v-on="on">Add configuration</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field v-model="editedItem.configuration" persistent-hint label="Configuration Name"
                            :rules="[(v) => !!v || 'required']"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field v-model="editedItem.value" persistent-hint label="Value"
                            :rules="[(v) => !!v || 'required']"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field v-model="editedItem.username" persistent-hint label="Username"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field v-model="editedItem.password" persistent-hint label="Password"></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="12" md="12">
                          <span v-if="editedIndex== -1">
                            <v-text-field outlined dense type="date" v-model="editedItem.fromdate" label="From Date"
                              hint="From Date"></v-text-field>
                          </span>
                          <span v-else>
                            <v-text-field outlined dense type="date" v-model="editedItem.from_date_edit"
                              label="From Date" hint="From Date"></v-text-field>
                          </span>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                          <span v-if="editedIndex== -1">
                            <v-text-field outlined dense type="date" v-model="editedItem.todate" label="End Date"
                              hint="End Date"></v-text-field>
                          </span>
                          <span v-else>
                            <v-text-field outlined dense type="date" v-model="editedItem.to_date_edit" label="End Date"
                              hint="End Date"></v-text-field>
                          </span>
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                          <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn class="mb-2 button" color="primary" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
            <v-btn small class="no-display" rounded color="white" outlined
          @click="fnExcelReport('mytable', 'ConfigurationMaster')"><v-icon
            color="white">mdi-export</v-icon>Export</v-btn>
          </v-toolbar>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
        </template>
        <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
      </v-data-table>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    isallowed:false,
    valid: false,
    overlay: false,
    errorMsg: {
      configuration: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    // extraBreadcrumbItems: [
    //   { text: "Configuration Master", disabled: true, href: "" },

    // ],
    breadcrumbClass: "breadcrumb-style2",
    headers: [
      {
        text: "Configuration Name",
        align: "left",
        sortable: false,
        value: "configuration",
      },
      {
        text: "Value",
        align: "left",
        sortable: false,
        value: "value",
      },
      {
        text: "Username",
        align: "left",
        sortable: false,
        value: "username",
      },
      {
        text: "Password",
        align: "left",
        sortable: false,
        value: "password",
      },
      {
        text: "From Date",
        align: "left",
        sortable: false,
        value: "from_date",
      },
      {
        text: "To Date",
        align: "left",
        sortable: false,
        value: "to_date",
      },
      {
        text: "Status",
        align: "left",
        sortable: true,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    configuration_master_list: [],
    editedIndex: -1,
    editedItem: {
      id: "",
      configuration: "",
      value: "",
      isactive: true,
      username: "",
      password: "",
      fromdate: null,
      todate:null,
    },
    defaultItem: {
      id: "",
      configuration: "",
      value: "",
      isactive: true,
      username: "",
      password: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "New Configuration"
        : "Edit Configuration";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },

  // created () {
  //   this.initialize()
  // },
  mounted() {
    this.onLoad();
  },
  methods: {
    //   initialize () {

    //   },
    fnExcelReport(id, name) {
      var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
      tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
      tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
      tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
      tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
      tab_text = tab_text + "<table border='1px'>";
      var exportTable = $("#" + id).clone();
      exportTable.find("input").each(function (index, elem) {
          $(elem).remove();
      });
       exportTable.find('th, td').each(function() {
          $(this).css('border', '1px solid black');
      });
      tab_text = tab_text + exportTable.html();
      tab_text = tab_text + "</table></body></html>";
      var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";
      const blob = new Blob([tab_text], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const filename = name + ".xls";

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // For IE
          window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
            // For modern browsers
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(url);
      }
    },
    editItem(item) {
      this.editedIndex = this.configuration_master_list.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    onLoad() {
      this.overlay = true;
      axios
        .post("/AdmissionMaster/Configuration")
        .then((res) => {
          this.overlay = false;
          if (res.data.flag == "YES") {
            this.overlay = false;
            this.configuration_master_list = res.data.configuration_array_list;
          }  else if (res.data.flag == "No"){
                            this.showSnackbar("red", res.data.snackbar);
                            this.isallowed=res.data.isallowed
                            this.overlay = false;
                            this.isallowed=res.data.isallowed
                            }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    // deleteItem (item) {
    //   const index = this.configuration_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.configuration_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/AdmissionMaster/edit_configuration", this.editedItem)
            .then((res) => {
              if (res.data.msg == "200") {
                //window.alert(res.data.msg)
                Object.assign(
                  this.configuration_master_list[this.editedIndex],
                  this.editedItem
                );
              }
              this.showSnackbar(
                "#4caf50",
                "Configuration Updated Successfully..."
              ); // show snackbar on success
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        }
      } else {
        axios
          .post("/AdmissionMaster/save_configuration", this.editedItem)
          .then((res) => {
            if (res.data.code == "SUCCESS") {
              //window.alert(res.data.status.code)
              this.configuration_master_list.push(this.editedItem);
              this.showSnackbar(
                "#4caf50",
                "Configuration Added Successfully..."
              ); // show snackbar on success
              this.onLoad();
            } else if (res.data.code == "NA") {
              //window.alert(res.data.status.code)
              //alert(res.data.status.message)
              this.showSnackbar("#b71c1c", "configuration Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, //save()
    isValidated() {
      if (this.editedItem.configuration) {
        return true;
      } else {
        if (!this.editedItem.configuration) {
          this.errorMsg.configuration = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>